function srcCrop(src, options) {
  let { width, height, crop = true } = options || {};
  const regExp = new RegExp('(.*)(.jpg|.jpeg|.png)$');
  let currentImage = src;
  if (currentImage) {
    let currentImageMatch = currentImage.match(regExp);
    if (currentImageMatch && currentImageMatch[1] && currentImageMatch[2]) {
      currentImage = `${currentImageMatch[1]}_${width}x${height}${
        !crop ? '_0' : ''
      }${currentImageMatch[2]}`;
      return currentImage;
    }
  }
}

export default srcCrop;
